module.exports = __webpack_public_path__ + "static/img/value-icon03-01.78729c14.png";